import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import List from '@mui/material/List';
import { Link as RouterLink } from 'react-router';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import { TextV2 } from '@insights-ltd/design-library/components';
import ListItemButton from '@mui/material/ListItemButton';
import HeaderLayout from './HeaderLayout';
import { NavBarItem } from './types';

type MobileNavBarDialogProps = {
  open: boolean;
  closeDialog: () => void;
  navBarItems: NavBarItem[];
};

const MobileNavBarDialog = ({
  open,
  closeDialog,
  navBarItems,
}: MobileNavBarDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog fullScreen open={open} onClose={closeDialog}>
      <HeaderLayout>
        <Grid
          container
          sx={{
            justifyContent: 'flex-end',
          }}
        >
          <IconButton
            onClick={closeDialog}
            aria-label={t('ui.event-management.events.close-label')}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </HeaderLayout>
      <List>
        {navBarItems.map(({ text, to }) => (
          <TextV2 component="p" variant="bodyBold" color="primary" key={text}>
            <ListItemButton
              component={RouterLink}
              to={to}
              onClick={closeDialog}
            >
              {text}
            </ListItemButton>
          </TextV2>
        ))}
      </List>
    </Dialog>
  );
};

export default MobileNavBarDialog;
